import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";

export const usePlayerAnimationStateManager = /* @__PURE__ */ create(
  /* @__PURE__ */ subscribeWithSelector<State>((set) => {
    return {
      /**
       * Character animations state manegement
       */
      // Initial animation
      curAnimation: null as unknown as string,
      animationSet: {} as AnimationSet,

      initializeAnimationSet: (animationSet: AnimationSet) => {
        set((state) => {
          if (Object.keys(state.animationSet).length === 0) {
            return { animationSet };
          }
          return {};
        });
      },

      reset: () => {
        set((state) => {
          return { curAnimation: state.animationSet.idle };
        });
      },

      idle: () => {
        set((state) => {
          if (state.curAnimation === state.animationSet.jumpIdle) {
            return { curAnimation: state.animationSet.jumpLand };
          } else if (
            state.curAnimation === state.animationSet.moveAndJumpIdle
          ) {
            return { curAnimation: state.animationSet.moveAndJumpLand };
          } else if (state.curAnimation !== state.animationSet.castSpell) {
            return { curAnimation: state.animationSet.idle };
          }
          return {};
        });
      },

      walk: () => {
        set((state) => {
          if (state.curAnimation !== state.animationSet.castSpell) {
            return { curAnimation: state.animationSet.walk };
          }
          return {};
        });
      },

      run: () => {
        set((state) => {
          if (state.curAnimation !== state.animationSet.castSpell) {
            return { curAnimation: state.animationSet.run };
          }
          return {};
        });
      },

      jump: () => {
        set((state) => {
          return { curAnimation: state.animationSet.jump };
        });
      },

      jumpIdle: () => {
        set((state) => {
          if (state.curAnimation === state.animationSet.jump) {
            return { curAnimation: state.animationSet.jumpIdle };
          }
          return {};
        });
      },

      jumpLand: () => {
        set((state) => {
          if (state.curAnimation === state.animationSet.jumpIdle) {
            return { curAnimation: state.animationSet.jumpLand };
          }
          return {};
        });
      },

      moveAndJump: () => {
        set((state) => {
          return { curAnimation: state.animationSet.moveAndJump };
        });
      },

      moveAndJumpIdle: () => {
        set((state) => {
          if (state.curAnimation === state.animationSet.moveAndJump) {
            return { curAnimation: state.animationSet.moveAndJumpIdle };
          }
          return {};
        });
      },

      moveAndJumpLand: () => {
        set((state) => {
          if (state.curAnimation === state.animationSet.moveAndJumpIdle) {
            return { curAnimation: state.animationSet.moveAndJumpLand };
          }
          return {};
        });
      },

      fall: () => {
        set((state) => {
          return { curAnimation: state.animationSet.fall };
        });
      },

      castSpell: () => {
        set((state) => {
          if (
            state.curAnimation === state.animationSet.idle ||
            state.curAnimation === state.animationSet.walk ||
            state.curAnimation === state.animationSet.run
          ) {
            return { curAnimation: state.animationSet.castSpell };
          }
          return {};
        });
      },

      /**
       * Additional animations
       */
      // triggerFunction: ()=>{
      //    set((state) => {
      //        return { curAnimation: state.animationSet.additionalAnimation };
      //    });
      // }
    };
  })
);

export type AnimationSet = {
  idle: string;
  walk: string;
  run: string;
  jump: string;
  jumpIdle: string;
  jumpLand: string;
  moveAndJump: string;
  moveAndJumpIdle: string;
  moveAndJumpLand: string;
  fall: string;
  castSpell: string;
};

type State = {
  curAnimation: string;
  animationSet: AnimationSet;
  initializeAnimationSet: (animationSet: AnimationSet) => void;
  reset: () => void;
} & {
  [key in keyof AnimationSet]: () => void;
};
